/*
 * Strong card row equalization.
 *
 * Groups .card-wrapper--strong cards by visual row and equalizes the title
 * (and badge) height so the price / installment line aligns across products
 * sitting side by side — including the AJAX-loaded product-recommendations
 * ("Você também pode gostar"), which the MutationObserver below catches.
 *
 * Loaded as an external asset (instead of an inline <script>) so it executes
 * reliably on the PDP, where the recommendations are injected via innerHTML
 * and inline scripts never run.
 */
(() => {
  if (window.TigerStrongCardRows) {
    window.TigerStrongCardRows.refresh();
    return;
  }

  const cardSelector = '#product-grid .card-wrapper--strong, .vh-product-slider .card-wrapper--strong, .related-products .card-wrapper--strong';
  let frameId = null;

  const groupByRow = (cards) => {
    return cards.reduce((rows, card) => {
      const top = Math.round(card.getBoundingClientRect().top);
      const row = rows.find((item) => Math.abs(item.top - top) < 4);

      if (row) {
        row.cards.push(card);
      } else {
        rows.push({ top, cards: [card] });
      }

      return rows;
    }, []);
  };

  const refresh = () => {
    frameId = null;
    const cards = Array.from(document.querySelectorAll(cardSelector));

    cards.forEach((card) => {
      card.style.removeProperty('--vh-row-badge-height');
      card.style.removeProperty('--vh-row-badge-gap');
      card.style.removeProperty('--vh-row-title-height');
    });

    groupByRow(cards).forEach((row) => {
      let badgeHeight = 0;
      let titleHeight = 0;

      row.cards.forEach((card) => {
        const badge = card.querySelector('.vh-card-badge');
        const title = card.querySelector('.card__heading--strong');

        if (badge) {
          badgeHeight = Math.max(badgeHeight, Math.ceil(badge.getBoundingClientRect().height));
        }

        if (title) {
          titleHeight = Math.max(titleHeight, Math.ceil(title.getBoundingClientRect().height));
        }
      });

      row.cards.forEach((card) => {
        card.style.setProperty('--vh-row-title-height', `${titleHeight}px`);

        if (badgeHeight > 0) {
          card.style.setProperty('--vh-row-badge-height', `${badgeHeight}px`);
          card.style.setProperty('--vh-row-badge-gap', window.matchMedia('(max-width: 749px)').matches ? '10px' : '8px');
        }
      });
    });
  };

  const schedule = () => {
    if (frameId) return;
    frameId = window.requestAnimationFrame(refresh);
  };

  window.TigerStrongCardRows = { refresh: schedule };
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('DOMContentLoaded', schedule);

  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
})();
